import ScheduleView from "@/components/echarts-part/CalendarShift/ScheduleView";
import AndonRespondList from "../components/wx/AndonRespondList";
import OpenIdInitPage from "../components/wx/OpenIdInitPage";
import SimpleAndonManagement from "../views/sithMes/prd/PrdOperationExcute/SimpleAndonManagement";
import LoadRatePage from "@/components/echarts-part/CalendarShift/LoadRatePage";
import RitaCameraPage from "@/views/sithMes/rita/RitaCameraPage";
import ScheduleDetailList from "@/components/echarts-part/CalendarShift/ScheduleDetailList";
import ScheduleOverView from "@/components/echarts-part/CalendarShift/ScheduleOverView";
import StorageBinPage from "@/components/echarts-part/storage/StorageBinPage";
import PreviewPdfV2 from "@/components/Pdf/PreviewPdfV2";
import ManLoadsPage from "@/components/echarts-part/man-loads/ManLoadsPage";
import MintalKpiLayout from "@/components/echarts-part/kpi/mintal/MintalKpiLayout";
import TestPage from "@/components/echarts-part/stuff/TestPage";
import KpiSettings from "@/components/echarts-part/kpi/sith/KpiSettings";
import CustomizedDiagramEdit from "@/components/LayoutMaps/openLayers/CustomizedDiagramEdit";
import CustomizedDiagramPage from "@/components/LayoutMaps/openLayers/CustomizedDiagramPage";
import CustomizedDiagramPieceSetting from "@/components/LayoutMaps/openLayers/CustomizedDiagramPieceSetting";
import KpiLayoutOldVersion from "@/components/echarts-part/kpi/sith/KpiLayoutOldVersion.vue";
import KpiLayoutContainer from "@/components/echarts-part/kpi/sith/KpiLayoutContainer.vue";
import FaceList from "@/components/Face/FaceList.vue";
import BomTreePage from "@/components/bom/BomTreePage.vue";
import TpmSpindleDataTsdList from "@/components/echarts-part/tpm/TpmSpindleDataTsdList";
import OeeLayoutContainer from "@/components/echarts-part/tpm/oee/OeeLayoutContainer.vue";
import OeeMesLayoutContainer from "@/components/echarts-part/tpm/oee/OeeMesLayoutContainer.vue";
import OeeQueryLayoutContainer from "@/components/echarts-part/tpm/oee/OeeQueryLayoutContainer.vue";
import QCPage from "@/components/jsc/QCPage.vue";
import QueryViewPage from "@/views/common/QueryViewPage.vue";
import DictionaryGroupEdit from "@/views/common/dictionaryEnum/DictionaryGroupEditPage.vue";
import DictionaryGroupEnumEditPage from "@/views/common/dictionaryEnum/DictionaryGroupEnumEditPage.vue";
import DictionaryEnumEditPage from "@/views/common/dictionaryEnum/DictionaryEnumEditPage.vue";
import QCTablePage from "@/components/jsc/QCTablePage.vue";
import ExportFileTaskList from "@/views/common/ExportFileTaskList.vue";
import DataLineChartsPage from "@/components/LayoutMaps/openLayers/DataLineChartsPage.vue";
import StocktakeQrCode from "@/components/wx/StocktakeQrCode.vue";

export default [
    {
        path: '/sithMes/prd/schedule',
        component: ScheduleView
    },
    {
        path: '/kpiLayout/:index',
        component: KpiLayoutContainer
    },
    {
        path: '/kpiLayoutOldVersion/:index',
        component: KpiLayoutOldVersion
    },
    {
        path: '/wx/andon/list',
        component: AndonRespondList
    },
    {
        path: '/wx/auth',
        component: OpenIdInitPage
    },
    {
        path: '/simple/andon',
        component: SimpleAndonManagement
    },
    {
        path: '/loadRate',
        component: LoadRatePage
    },
    {
        path: '/ritaPage',
        component: RitaCameraPage
    },
    {
        path: '/sithMes/prd/schedule/list',
        component: ScheduleDetailList
    },
    {
        path: '/sithMes/prd/schedule/over',
        component: ScheduleOverView
    },
    {
        path: '/storage/binPage',
        component: StorageBinPage
    },
    {
        path: '/pdf/previewer',
        component: PreviewPdfV2
    },
    {
        path: '/manLoads',
        component: ManLoadsPage
    },
    {
        path: '/mintalKpi',
        component: MintalKpiLayout
    },
    {
        path: '/test',
        component: TestPage
    },
    {
        path: '/kpiSettings',
        component: KpiSettings
    },
    {
        path: '/customizedDiagramEdit',
        name: 'customizedDiagramEdit',
        component: CustomizedDiagramEdit
    },
    {
        path: '/customizedDiagram',
        name: 'customizedDiagram',
        component: CustomizedDiagramPage
    },
    {
        path: '/customizedDiagramSetting',
        name: 'customizedDiagramSetting',
        component: CustomizedDiagramPieceSetting
    },
    {
        path: '/dataLineChartsPage',
        name: 'dataLineChartsPage',
        component: DataLineChartsPage
    },
    {
        path: '/face/manage',
        component: FaceList
    },
    {
        path: '/materialBom',
        component: BomTreePage
    },
    {
        path: '/sithMes/tpm/spindleDataTsd/list',
        component: TpmSpindleDataTsdList
    },
    {
        path: '/oeeLayout',
        component: OeeLayoutContainer
    },
    {
        path: '/oeeMesLayout',
        component: OeeMesLayoutContainer
    },
    {
        path: '/oeeQueryLayout',
        component: OeeQueryLayoutContainer
    },
    {
        path: '/dictionaryEnum/:code',
        component: DictionaryEnumEditPage,
        props: (route) => ({withLabel: route.query.withLabel}),
    },
    {
        path: '/dictionaryGroupEnum/:group',
        component: DictionaryGroupEnumEditPage
    },
    {
        path: '/dictionaryGroup',
        component: DictionaryGroupEdit
    },
    {
        path: '/query/config',
        component: QCPage
    },
    {
        path: '/query/view/:code',
        component: QueryViewPage,
        props: (r) => ({
            enableEdit: String(r.query.enableEdit).toLowerCase() === 'true',
            editFormName: r.query.editFormName,
            enableImport: String(r.query.enableImport).toLowerCase() === 'true',
            importFormName: r.query.importFormName,
            disableExport: String(r.query.disableExport).toLowerCase() === 'true',
        })
    },
    {
        path: '/query/config/table',
        component: QCTablePage
    },
    {
        path: '/export/file/list',
        component: ExportFileTaskList
    },
    {
        path: '/wx/stocktake/qrCode',
        component: StocktakeQrCode
    },
]
